import React from "react";
import { FaBan } from "react-icons/fa";

const BlockedScreen = ({ blockInfo }) => {
  const { reason, blockedUntil } = blockInfo || {};

  const formattedReason = reason
    ? reason.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())
    : "Security reasons";

  const formattedBlockedUntil = blockedUntil
    ? new Date(blockedUntil).toLocaleString()
    : "an indefinite period";

  return (
    <div className="bg-gray-50 dark:bg-gray-900 p-4">
      <div className="w-full max-w-md p-8 space-y-6 bg-white dark:bg-gray-800 rounded-2xl shadow-2xl border border-red-500/30 mx-auto">
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <div className="p-4 bg-red-500/10 rounded-full border border-red-500/30">
              <FaBan className="text-5xl text-red-500 dark:text-red-400" />
            </div>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            Access Denied
          </h1>
          <p className="mt-2 text-gray-600 dark:text-gray-400">
            Your connection has been blocked by our security system.
          </p>
        </div>

        <div className="space-y-4 text-center bg-gray-100 dark:bg-gray-700/50 p-4 rounded-lg">
          <div>
            <h2 className="text-sm font-medium text-gray-500 dark:text-gray-400">
              Reason
            </h2>
            <p className="text-lg font-semibold text-red-600 dark:text-red-400">
              {formattedReason}
            </p>
          </div>
        </div>

        <p className="text-xs text-center text-gray-500 dark:text-gray-400">
          If you believe this is a mistake, please contact our support team.
        </p>
      </div>
    </div>
  );
};

export default BlockedScreen;
